import * as React from 'react';

import LoadableERPBarChart from './LoadableERPBarChart';
import LoadableERPQuadrantChart from './LoadableERPQuadrantChart';
import LoadableERPChart from '~/MedicinalBrandsAnalytics/VirtualBrand/ERPTab/LoadableERPChart';

import { ERPRequestApiResult } from './api/ERPSessionRequest';
import { parseERPApiResult } from '~/MedicinalBrandsAnalytics/VirtualBrand/ERPTab/utils/ERPApiParser';
import ERPRevenueSummary from './ERPRevenueSummary';

interface ERPBaseScenarioProps {
	currency: string;
	erpSessionResult: ERPRequestApiResult;
	virtualProductPackName: string;
	onDataAddRequest: () => void;
}

const ERPBaseScenario = ({
	currency,
	erpSessionResult,
	virtualProductPackName,
	onDataAddRequest,
}: ERPBaseScenarioProps) => {
	const parsedErpResult = parseERPApiResult(
		erpSessionResult.value?.erpSessionDetail.erpModelResult || null,
		erpSessionResult
	);

	return (
		<div className='px-10 bg-white'>
			<div className='py-8 w-full max-w-7xl mx-auto border-b border-gray-200'>
				<h2 className='mb-1 font-display text-h3 font-semibold text-cPurple-600'>Base Scenario</h2>
				<ERPRevenueSummary
					currency={currency}
					erpModelResult={erpSessionResult.value?.erpSessionDetail.erpModelResult}
				/>
				<div className='pt-2 flex justify-between w-full'>
					<div className='w-1/2 pr-2'>
						<LoadableERPQuadrantChart apiResult={erpSessionResult} />
					</div>
					<div className='w-1/2 pl-2'>
						<LoadableERPBarChart
							apiResult={erpSessionResult}
							currency={currency}
							erpModelResult={erpSessionResult.value?.erpSessionDetail.erpModelResult}
							onDataAddRequest={onDataAddRequest}
						/>
					</div>
				</div>
				<div className='pb-8'>
					<LoadableERPChart hideSummaries result={parsedErpResult} virtualProductPackName={virtualProductPackName} />
				</div>
			</div>
		</div>
	);
};

export default React.memo(ERPBaseScenario);
